import {action, observable} from "mobx";
import {IBlogPost, IBlogPostDetails} from "../models/blog-post";
import {NoticeTypeEnum} from "../models/notice";
import SimpleStore from "./base/simple-store";
import RootStore from "./root-store";

export default class BlogStore extends SimpleStore {
    public imgRootPath: string;

    @observable
    public posts: IBlogPost[];

    @observable
    public postDetails: IBlogPostDetails;

    constructor(rootStore: RootStore) {
        super(rootStore);
        this.imgRootPath = `${process.env.REACT_APP_WEB_SERVICE_ENDPOINT}/img/blog`;
    }

    public async getPosts() {
        try {
            this.startFetching();
            const result = await this.rootStore.blogApi.getPosts();
            this.setPosts(result.data);
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
        } finally {
            this.finishFetching();
        }
    }

    public async getPostDetails(id: number) {
        try {
            this.startFetching();
            const result = await this.rootStore.blogApi.getPostDetails(id);
            this.setPostDetails(result.data);
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
        } finally {
            this.finishFetching();
        }
    }

    @action
    private setPosts(posts: IBlogPost[]) {
        this.posts = posts;
    }

    @action
    private setPostDetails(post: IBlogPostDetails) {
        this.postDetails = post;
    }
}



// WEBPACK FOOTER //
// ./src/stores/blog-store.ts